import React from "react";
import { useSelector } from "react-redux";
import { Cookies } from '../../index.js';
import Homehealing from '../../community/process/homehealing.jsx';
import HomeBirdHero from '../../community/process/home_bird.jsx';
import Process_ip from './process_ip.jsx';
import National_market from '../../community/process/national_market.jsx';
import { isLocalHost } from '../../shared/host_utils.js';

const Process_main = () => {
    const latest_version = useSelector(state => state.latest_version);
    const national_market = useSelector(state => state.national_market);
    const isBootstrapping = latest_version === false;
    const getMainDomain = () => {
        const parts = window.location.hostname.split('.');
        return parts.length > 2 ? parts[parts.length - 2] : parts[0];
    };
    const hostname = window.location.hostname.toLowerCase();
    const main_domain = !isLocalHost(window.location.hostname)
        ? (Cookies.get("main_domain") || getMainDomain() || "hust")
        : (Cookies.get("main_domain") || "hust");
    const normalizedDomain = String(main_domain || '').toLowerCase();
    const isBirdDomain =
        normalizedDomain.includes('bird') ||
        hostname.includes('bird');
    const birdGlassPanel = "relative bg-slate-950/40 bg-hust-glass backdrop-blur-md border border-white/10 hover:border-hust-pink/50 transition-all duration-500 shadow-lg hover:shadow-hust-pink/20 rounded-2xl sm:rounded-3xl pt-4 pr-3 pb-4 pl-3 sm:pt-6 sm:pr-6 sm:pb-6 sm:pl-6 group";
    const birdCtaLinkProps = { to: "/shop/auth/login_home" };
    const birdDocLinkProps = { to: "/next/docs/overview", reloadDocument: true };

    return (
        <>
            {!national_market ? (
                (isBootstrapping || latest_version != '') ? (
                    <Process_ip />
                ) : (
                    <National_market />
                )
            ) : (
                isBirdDomain ? (
                    <HomeBirdHero
                        className="mx-3 my-4"
                        glassPanel={birdGlassPanel}
                        ctaLinkProps={birdCtaLinkProps}
                        ctaLabel="Go to Console"
                        docLinkProps={birdDocLinkProps}
                    />
                ) : (
                    <Homehealing />
                )
            )}
        </>
    );
};

export default Process_main;
